import TopStoresTableContainer from "./container";
import TopStoresTable from "./component";

export { TopStoresTableContainer, TopStoresTable };



// WEBPACK FOOTER //
// ./client/modules/StoreVisits/components/TopStoresTable/index.tsx